<section role="dialog" aria-modal="true" aria-labelledby="legal-info-title"
  class="sm:min-h-[40.6rem] sm:w-[51.2rem] min-h-[40vh] w-[70vw] relative flex flex-col items-center justify-center">
  <button type="button" class="absolute top-[4rem] right-[4rem] cursor-pointer" (click)="closePopup()"
    aria-label="Close legal information">
    <dsr-icon name="cancel" size="1.6rem" color="black" aria-hidden="true"></dsr-icon>
  </button>
  <div class="h-[80%] w-[90%vw] flex flex-col justify-between items-center gap-[4rem]">
    <div class="flex flex-col items-center justify-center">
      <h2 mat-dialog-title id="legal-info-title">
        {{ "FOOTER_INFORMATION_TITLE3" | translate }}
      </h2>
    </div>

    <mat-dialog-content class="!max-h-none !w-full !p-0">
      <div aria-label="Legal documents" class="min-w-fit justify-center h-full flex flex-col gap-[4rem] items-center">
        <a class="w-full block px-8" [href]="tcDoc" target="_blank" rel="noopener noreferrer"
          aria-label="Terms and conditions (opens in new tab)">
          <button class="w-full" mat-stroked-button color="primary" type="button">
            <span class="first-letter:uppercase">{{ "REGISTRATION_TC" | translate }}</span>
          </button>
        </a>

        <a [href]="cookiePolicyDoc" class="w-full block px-8" target="_blank" rel="noopener noreferrer"
          aria-label="Cookies policy (opens in new tab)">
          <button class="w-full" mat-stroked-button color="primary" type="button">
            <span class="first-letter:uppercase">{{ "COOKIES_POLICY" | translate }}</span>
          </button>
        </a>

        <a class="w-full block px-8" [href]="dataPrivacyDoc" target="_blank" rel="noopener noreferrer"
          aria-label="Personal data privacy (opens in new tab)">
          <button class="w-full" mat-stroked-button color="primary" type="button">
            <span class="first-letter:uppercase">{{ "PERSONAL_DATA" | translate }}</span>
          </button>
        </a>
      </div>
    </mat-dialog-content>
  </div>
</section>